import { render } from "./PermitLookup.vue?vue&type=template&id=aefa806a"
import script from "./PermitLookup.vue?vue&type=script&lang=ts"
export * from "./PermitLookup.vue?vue&type=script&lang=ts"
script.render = render
/* custom blocks */
import block0 from "./PermitLookup.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script